module.exports = __webpack_public_path__ + "static/img/prepa-success.44ec8a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/01/prepa-success.jpg
// module id = UeUE
// module chunks = 1